import { a as m } from "./isObjectLike.YJTOHc8M.js";
import { i as y } from "./isArray.CAJdVVdL.js";
import { i as p } from "./isSymbol.CZPCZPYP.js";
function b(r, t) {
  for (var i = -1, n = r == null ? 0 : r.length, o = Array(n); ++i < n; )
    o[i] = t(r[i], i, r);
  return o;
}
var l = b, s = m, S = l, g = y, _ = p, a = s ? s.prototype : void 0, e = a ? a.toString : void 0;
function f(r) {
  if (typeof r == "string")
    return r;
  if (g(r))
    return S(r, f) + "";
  if (_(r))
    return e ? e.call(r) : "";
  var t = r + "";
  return t == "0" && 1 / r == -1 / 0 ? "-0" : t;
}
var h = f;
export {
  h as _
};
//# sourceMappingURL=_baseToString.B41tpU4a.js.map
